import config from '../config'
import { authorizedFetch } from '../utils/auth.js'
import { checkStatus } from '../utils/fetch'
import { logOut } from '../actions/users'

export const REQUEST_BUILDINGS = 'REQUEST_BUILDINGS'
export const RECEIVED_BUILDINGS = 'RECEIVED_BUILDINGS'
export const SHOW_ADD_BUILDING_FORM = 'SHOW_ADD_BUILDING_FORM'
export const CLOSE_ADD_BUILDING_FORM = 'CLOSE_ADD_BUILDING_FORM'
export const UPDATE_BUILDING_FIELD = 'UPDATE_BUILDING_FIELD'
export const UPDATE_BUILDING = 'UPDATE_BUILDING'
export const UPDATE_BUILDING_SUCCEDED = 'UPDATE_BUILDING_SUCCEDED'
export const DELETE_BUILDING = 'DELETE_BUILDING'
export const DELETE_BUILDING_SUCCEDED = 'DELETE_BUILDING_SUCCEDED'
export const CHANGE_BUILDING_IMAGE = 'CHANGE_BUILDING_IMAGE'
export const CANCEL_BUILDING_IMAGE = 'CANCEL_BUILDING_IMAGE'
export const SHOW_SPINNER_BUILDINGS = 'SHOW_SPINNER_BUILDINGS'
export const CHANGE_MARKER_POSITION = 'CHANGE_MARKER_POSITION'
export const SHOW_ERROR_BUILDINGS = 'SHOW_ERROR_BUILDINGS'
export const UPDATE_START_TIME = 'UPDATE_START_TIME'
export const UPDATE_END_TIME = 'UPDATE_END_TIME'
export const UPDATE_BRIVO = 'UPDATE_BRIVO'
export const UPDATE_RESIDENTIAL = 'UPDATE_RESIDENTIAL'
export const CHANGE_PAGE = 'CHANGE_PAGE_BUILDINGS'

export const DELETE_TOKEN_SUCCEDED = 'DELETE_TOKEN_SUCCEDED'
export const GENERATE_TOKENS = 'GENERATE_TOKENS'
export const UPDATE_NUMBER_OF_TOKENS = 'UPDATE_NUMBER_OF_TOKENS'

export const REQUEST_TOKENS = 'REQUEST_TOKENS'
export const RECEIVED_TOKENS = 'RECEIVED_TOKENS'

export const SHOW_TOKENS = 'SHOW_TOKENS'
export const CLOSE_TOKENS_MODAL = 'CLOSE_TOKENS_MODAL'

export const SHOW_TOKEN_FORM = 'SHOW_TOKEN_FORM'
export const SHOW_CUSTOMIZE_FORM = 'SHOW_CUSTOMIZE_FORM'
export const CLOSE_TOKEN_FORM = 'CLOSE_TOKEN_FORM'

export const FETCH_COMPANIES_SUCCEDED = 'FETCH_COMPANIES_SUCCEDED'
export const UPDATE_COMPANY_TOKEN = 'UPDATE_COMPANY_TOKEN'
export const CLOSE_CUSTOMIZE_BUILDING_FORM = 'CLOSE_CUSTOMIZE_BUILDING_FORM'

export const SHOW_GENERATE_TOKEN_ERROR = 'SHOW_GENERATE_TOKEN_ERROR'
export const CANCEL_UNLOCK_IMAGE = 'CANCEL_UNLOCK_IMAGE'
export const CHANGE_UNLOCK_IMAGE = 'CHANGE_UNLOCK_IMAGE'
export const CHANGE_LOCK_IMAGE = 'CHANGE_LOCK_IMAGE'
export const CANCEL_LOCK_IMAGE = 'CANCEL_LOCK_IMAGE'
export const CANCEL_SELECTED_HOME_IMAGE = 'CANCEL_SELECTED_HOME_IMAGE'
export const CHANGE_SELECTED_HOME_IMAGE = 'CHANGE_SELECTED_HOME_IMAGE'
export const CANCEL_UNSELECTED_HOME_IMAGE = 'CANCEL_UNSELECTED_HOME_IMAGE'
export const CHANGE_UNSELECTED_HOME_IMAGE = 'CHANGE_UNSELECTED_HOME_IMAGE'
export const CANCEL_CHECKIN_IMAGE = 'CANCEL_CHECKIN_IMAGE'
export const CHANGE_CHECKIN_IMAGE = 'CHANGE_CHECKIN_IMAGE'
export const CANCEL_SELECTED_PROFILE_IMAGE = 'CANCEL_SELECTED_PROFILE_IMAGE'
export const CHANGE_SELECTED_PROFILE_IMAGE = 'CHANGE_SELECTED_PROFILE_IMAGE'
export const CANCEL_UNSELECTED_PROFILE_IMAGE = 'CANCEL_UNSELECTED_PROFILE_IMAGE'
export const CHANGE_UNSELECTED_PROFILE_IMAGE = 'CHANGE_UNSELECTED_PROFILE_IMAGE'
export const UPDATE_DO_CUSTOMIZE_BUILDING_FIELD = 'UPDATE_DO_CUSTOMIZE_BUILDING_FIELD'
export const UPDATE_BOOK_CUSTOMIZE_BUILDING_FIELD = 'UPDATE_BOOK_CUSTOMIZE_BUILDING_FIELD'
export const UPDATE_ASSEMBLY_CUSTOMIZE_BUILDING_FIELD = 'UPDATE_ASSEMBLY_CUSTOMIZE_BUILDING_FIELD'
export const UPDATE_FILTER_CUSTOMIZE_BUILDING_FIELD = 'UPDATE_FILTER_CUSTOMIZE_BUILDING_FIELD'

export const showGenerateTokenError = error => ({
  type: SHOW_GENERATE_TOKEN_ERROR,
  generateError: error
})

export const updateTokenCompany = companyId => ({
  type: UPDATE_COMPANY_TOKEN,
  companyId: companyId
})

export const fetchCompaniesForBuilding = building => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'buildings/companies/', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ building: building })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(fetchCompaniesSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const fetchCompaniesSucceded = companies => ({
  type: FETCH_COMPANIES_SUCCEDED,
  companies: companies
})

export const deleteToken = token => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'tokens/delete', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ token: token })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(deleteTokenSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const deleteTokenSucceded = token => ({
  type: DELETE_TOKEN_SUCCEDED,
  token: token
})

export const generateTokens = (building, numberOfTokens, companyId) => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'tokens/generate/' + building._id, {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ tokens_number: numberOfTokens, company_id: companyId })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => {
      let downloadUrl = json['download_url']
      window.open(downloadUrl, '_blank')
    })
    .then(json => dispatch(fetchTokens(building)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const updateNumberOfTokens = numberOfTokens => ({
  type: UPDATE_NUMBER_OF_TOKENS,
  numberOfTokens: numberOfTokens
})

export const requestTokens = () => ({
  type: REQUEST_TOKENS
})

export const receivedTokens = json => ({
  type: RECEIVED_TOKENS,
  json: json.data
})

export const fetchTokens = building => dispatch => {
  dispatch(requestTokens())
  authorizedFetch(config.api_url + 'tokens/list/' + building._id)
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receivedTokens({ data: json })))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const showTokens = building => ({
  type: SHOW_TOKENS,
  building: building
})

export const showCustomizeForm = building => ({
  type: SHOW_CUSTOMIZE_FORM,
  building
})

export const closeTokensModal = () => ({
  type: CLOSE_TOKENS_MODAL
})

export const showTokenForm = token => ({
  type: SHOW_TOKEN_FORM,
  token: token
})

export const closeTokenForm = () => ({
  type: CLOSE_TOKEN_FORM
})

export const updateBrivo = brivo => ({
  type: UPDATE_BRIVO,
  value: brivo
})

export const displayError = error => ({
  type: SHOW_ERROR_BUILDINGS,
  error: error
})

export const cancelImage = () => ({
  type: CANCEL_BUILDING_IMAGE
})

export const cancelUnlockImage = () => ({
  type: CANCEL_UNLOCK_IMAGE
})

export const cancelLockImage = () => ({
  type: CANCEL_LOCK_IMAGE
})

export const cancelSelectedHomeImage = () => ({
  type: CANCEL_SELECTED_HOME_IMAGE
})

export const cancelUnselectedHomeImage = () => ({
  type: CANCEL_UNSELECTED_HOME_IMAGE
})

export const cancelCheckInImage = () => ({
  type: CANCEL_CHECKIN_IMAGE
})

export const cancelSelectedProfileImage = () => ({
  type: CANCEL_SELECTED_PROFILE_IMAGE
})

export const cancelUnselectedProfileImage = () => ({
  type: CANCEL_UNSELECTED_PROFILE_IMAGE
})

export const changeImage = image => ({
  type: CHANGE_BUILDING_IMAGE,
  image: image
})

export const changeUnlockImage = unlockImage => ({
  type: CHANGE_UNLOCK_IMAGE,
  unlockImage
})

export const changeLockImage = lockImage => ({
  type: CHANGE_LOCK_IMAGE,
  lockImage
})

export const changeSelectedHomeImage = selectedHomeImage => ({
  type: CHANGE_SELECTED_HOME_IMAGE,
  selectedHomeImage
})

export const changeUnselectedHomeImage = unselectedHomeImage => ({
  type: CHANGE_UNSELECTED_HOME_IMAGE,
  unselectedHomeImage
})

export const changeCheckInImage = checkInImage => ({
  type: CHANGE_CHECKIN_IMAGE,
  checkInImage
})

export const changeSelectedProfileImage = selectedProfileImage => ({
  type: CHANGE_SELECTED_PROFILE_IMAGE,
  selectedProfileImage
})

export const changeUnselectedProfileImage = unselectedProfileImage => ({
  type: CHANGE_UNSELECTED_PROFILE_IMAGE,
  unselectedProfileImage
})

export const requestBuildings = () => ({
  type: REQUEST_BUILDINGS
})

export const receivedBuildings = json => ({
  type: RECEIVED_BUILDINGS,
  json: json.data
})

export const fetchBuildings = (skip, take) => dispatch => {
  dispatch(requestBuildings())
  authorizedFetch(config.api_url + `buildings/list?skip=${skip}&take=${take}`)
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receivedBuildings({ data: json })))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const showUpdateBuildingForm = building => ({
  type: SHOW_ADD_BUILDING_FORM,
  building: building
})

export const closeAddBuildingForm = () => ({
  type: CLOSE_ADD_BUILDING_FORM
})

export const closeCustomizeBuildingForm = () => ({
  type: CLOSE_CUSTOMIZE_BUILDING_FORM
})

export const updateField = (name, value) => ({
  type: UPDATE_BUILDING_FIELD,
  name: name,
  value: value
})

export const updateDoCustomizeField = (name, value) => ({
  type: UPDATE_DO_CUSTOMIZE_BUILDING_FIELD,
  name: name,
  value: value
})

export const updateBookCustomizeField = (name, value) => ({
  type: UPDATE_BOOK_CUSTOMIZE_BUILDING_FIELD,
  name: name,
  value: value
})

export const updateAssemblyCustomizeField = (name, value) => ({
  type: UPDATE_ASSEMBLY_CUSTOMIZE_BUILDING_FIELD,
  name: name,
  value: value
})

export const updateFilterCustomizeField = (name, value) => ({
  type: UPDATE_FILTER_CUSTOMIZE_BUILDING_FIELD,
  name: name,
  value: value
})

export const updateCustomizeBuilding = building => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  let base64Prefix = /^data:image\/\w+;base64,/

  if (building.newUnlockImage) {
    building.newUnlockImage = atob(building.newUnlockImage.replace(base64Prefix, ''))
  }
  if (building.newLockImage) {
    building.newLockImage = atob(building.newLockImage.replace(base64Prefix, ''))
  }
  if (building.homeImage && building.homeImage.newSelectedHomeImage) {
    building.homeImage.newSelectedHomeImage = atob(building.homeImage.newSelectedHomeImage.replace(base64Prefix, ''))
  }
  if (building.homeImage && building.homeImage.newUnselectedHomeImage) {
    building.homeImage.newUnselectedHomeImage = atob(
      building.homeImage.newUnselectedHomeImage.replace(base64Prefix, '')
    )
  }
  if (building.newCheckInImage) {
    building.newCheckInImage = atob(building.newCheckInImage.replace(base64Prefix, ''))
  }
  if (building.profileImage && building.profileImage.newSelectedProfileImage) {
    building.profileImage.newSelectedProfileImage = atob(
      building.profileImage.newSelectedProfileImage.replace(base64Prefix, '')
    )
  }
  if (building.profileImage && building.profileImage.newUnselectedProfileImage) {
    building.profileImage.newUnselectedProfileImage = atob(
      building.profileImage.newUnselectedProfileImage.replace(base64Prefix, '')
    )
  }

  authorizedFetch(config.api_url + 'buildings/updateCustomize', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ building: building })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateBuildingSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const updateBuilding = building => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  let base64Prefix = /^data:image\/\w+;base64,/

  if (building.newImage) {
    building.newImage = atob(building.newImage.replace(base64Prefix, ''))
  }

  authorizedFetch(config.api_url + 'buildings/update', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ building: building })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateBuildingSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const updateBuildingSucceded = building => ({
  type: UPDATE_BUILDING_SUCCEDED,
  building: building
})

export const deleteBuilding = building => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'buildings/delete', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ building: building })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(deleteBuildingSucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const deleteBuildingSucceded = building => ({
  type: DELETE_BUILDING_SUCCEDED,
  building: building
})

export const showSpinnerBuildings = () => ({
  type: SHOW_SPINNER_BUILDINGS
})

export const changeMarkerPosition = position => ({
  type: CHANGE_MARKER_POSITION,
  position: position
})

export const updateStartTime = (name, value) => ({
  type: UPDATE_START_TIME,
  name: name,
  value: value
})

export const updateEndTime = (name, value) => ({
  type: UPDATE_END_TIME,
  name: name,
  value: value
})

export const updateResidential = (name, enabled) => ({
  type: UPDATE_RESIDENTIAL,
  enabled,
  name
})

export const changePage = pageNumber => ({
  type: CHANGE_PAGE,
  pageNumber: pageNumber
})



// WEBPACK FOOTER //
// ./src/actions/buildings.js